import { Activity } from '../../types/activities'
import { ActivityItem } from './ActivityItem'
import { RegistrationCheckContext } from '../../providers/registration-check-provider'
import { ReactElement, useContext } from 'react'

type Props = {
    updateActivity: (activity: Activity) => void
    deleteActivity: (activity: Activity) => void
}

export const Activities = ({ updateActivity, deleteActivity }: Props): ReactElement => {
    const { activities } = useContext(RegistrationCheckContext)

    return (
        <div>
            {activities &&
                activities.map((activity) => (
                    <ActivityItem
                        key={activity.id}
                        activity={activity}
                        canBeDeleted={activities.length > 1}
                        deleteActivity={() => deleteActivity(activity)}
                        updateActivity={updateActivity}
                    />
                ))}
        </div>
    )
}
